import { DsRadio, DsRadioGroup } from '@pulsepointinc/design-system-react';
import { type FC, useId } from 'react';
import useExpressionTypeSelector from './hooks/useExpressionTypeSelector';
import { StyledDivider } from './styles';

interface ExpressionTypeSelectorProps {
  filterName: string;
  onExpressionTypeChange?: (value: string) => void;
  divider?: boolean;
}

const ExpressionTypeSelector: FC<ExpressionTypeSelectorProps> = ({
  filterName,
  onExpressionTypeChange,
  divider = true,
}) => {
  const radioGroupId = useId();
  const { initialToggleValue, handleRadioChange } = useExpressionTypeSelector(filterName, onExpressionTypeChange);

  return (
    <>
      <DsRadioGroup
        name={radioGroupId}
        orientation="horizontal"
        value={initialToggleValue}
        onValueChange={(e) => handleRadioChange(e.detail as 'target' | 'block')}
      >
        <DsRadio name={radioGroupId} label="Include Selected" value="target" />
        <DsRadio name={radioGroupId} label="Exclude Selected" value="block" />
      </DsRadioGroup>
      {divider && <StyledDivider />}
    </>
  );
};

export default ExpressionTypeSelector;
